<template>
  <div class="dashboard-panel">
    <h3 class="section-title mb-4">
      <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Portfolio Health Score
    </h3>
    <v-chart class="w-full h-64" :option="chartOption" autoresize />
    <div class="text-center mt-2">
      <span class="text-2xl font-bold" :class="scoreClass">{{ healthLabel }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent } from 'echarts/components'
import VChart from 'vue-echarts'

use([CanvasRenderer, GaugeChart, TitleComponent, TooltipComponent])

const props = defineProps({
  score: { type: Number, required: true },
  label: { type: String, required: true }
})

const scoreClass = computed(() => {
  if (props.score >= 80) return 'text-on-track'
  if (props.score >= 60) return 'text-at-risk'
  return 'text-delayed'
})

const chartOption = computed(() => ({
  series: [{
    type: 'gauge',
    startAngle: 180,
    endAngle: 0,
    min: 0,
    max: 100,
    splitNumber: 5,
    itemStyle: {
      color: props.score >= 80 ? '#10b981' : props.score >= 60 ? '#f59e0b' : '#ef4444'
    },
    progress: {
      show: true,
      width: 18
    },
    pointer: {
      show: true,
      length: '65%',
      width: 8,
      itemStyle: { color: '#1e3a5f' }
    },
    axisLine: {
      lineStyle: {
        width: 22,
        color: [[0.6, '#ef4444'], [0.8, '#f59e0b'], [1, '#10b981']]
      }
    },
    axisTick: { show: false },
    splitLine: { length: 14, lineStyle: { width: 2, color: '#cbd5e1' } },
    axisLabel: { distance: 22, color: '#64748b', fontSize: 10 },
    anchor: { show: true, showAbove: true, size: 20, itemStyle: { borderWidth: 4, color: '#fff', borderColor: '#1e3a5f' } },
    title: { show: false },
    detail: {
      valueAnimation: true,
      fontSize: 28,
      fontWeight: 'bold',
      offsetCenter: [0, '30%'],
      formatter: '{value}/100',
      color: '#1e293b'
    },
    data: [{ value: props.score, name: 'Health' }]
  }]
}))
</script>
